import React from 'react';
import { motion } from 'framer-motion';
import { Box } from '@mui/material';

export const PreLoader = ({ show, length = 3 }) => {
  return (
    <Loader
      show={show}
      length={length}
      color="#4174b9"
    />
  );
};

export const PreLoaderBiz = ({ show, length = 3 }) => {
  return (
    <Loader
      show={show}
      length={length}
      color="#295F47"
    />
  );
};

const Loader = ({ show, length, color }) => {
  const loaderContainer = {
    start: {
      transition: {
        staggerChildren: 0.1,
      },
    },
    end: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const cVariants = {
    start: { y: '0%' },
    end: { y: ['-100%', '0%', '0%', '0%', '0%'] },
  };

  const cTransition = {
    duration: 0.7,
    repeat: Infinity,
    repeatType: 'reverse',
    ease: 'easeInOut',
  };

  const circle = {
    width: 12,
    height: 12,
    backgroundColor: color,
    borderRadius: '50%',
    marginLeft: 10,
  };

  return (
    <Box
      height="100%"
      width="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      {show && <AcadLogo />}

      <Box pr="10px">
        <motion.div
          variants={loaderContainer}
          initial="start"
          animate="end"
          style={{ display: 'flex' }}
        >
          {(length === 3 ? Array(3) : Array(4)).fill(0).map((_, k) => (
            <motion.div
              key={k}
              style={circle}
              variants={cVariants}
              transition={cTransition}
            />
          ))}
        </motion.div>
      </Box>
    </Box>
  );
};

const AcadLogo = () => {
  return (
    <Box
      component={motion.div}
      pb={4}
    >
      <img
        src="/icons/pof-acad.svg"
        alt="POF Academy"
        width={70}
        height={70}
        loading="lazy"
      />
    </Box>
  );
};
